import { serializeRequestMetadataExtensions, } from "@lg-plus/landing-modules/lg-api";
const DEFAULT_MAX_POLL_RETRIES = 36;
const DEFAULT_POLL_RETRY_DELAY_MS = 5000;
const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
const safeResolveRequestMetadataExtensions = async (resolve) => {
    try {
        return await resolve();
    }
    catch {
        // Request metadata extensions must never block or fail business requests.
        return undefined;
    }
};
const fetchPollResult = async (requestId, maxRetries, retryDelayMs, ext) => {
    let lastError;
    for (let attempt = 0; attempt <= maxRetries; attempt++) {
        try {
            const res = await fetch(`/api/poll/?id=${requestId}`, {
                headers: serializeRequestMetadataExtensions(ext),
            });
            if (!res.ok) {
                throw new Error(`Failed to poll request: ${res.statusText}`);
            }
            return (await res.json());
        }
        catch (err) {
            lastError = err;
            if (attempt < maxRetries) {
                await delay(retryDelayMs);
            }
        }
    }
    throw lastError;
};
export const makeLGController = (options) => {
    const maxRetries = options?.maxPollRetries ?? DEFAULT_MAX_POLL_RETRIES;
    const retryDelayMs = options?.pollRetryDelayMs ?? DEFAULT_POLL_RETRY_DELAY_MS;
    const resolveRequestMetadataExtensions = options?.resolveRequestMetadataExtensions ?? (async () => undefined);
    const poll = async (requestId, requestMetadataExtensions) => {
        const ext = requestMetadataExtensions ??
            (await safeResolveRequestMetadataExtensions(resolveRequestMetadataExtensions));
        const result = await fetchPollResult(requestId, maxRetries, retryDelayMs, ext);
        if (result.command.kind === "await") {
            await delay(result.command.pollAfterMs ?? retryDelayMs);
            // Reuse the same extensions payload for the same logical polling operation.
            return poll(requestId, ext);
        }
        return result;
    };
    return {
        poll,
        async submitForm(payload) {
            const ext = await safeResolveRequestMetadataExtensions(resolveRequestMetadataExtensions);
            const res = await fetch("/api/submit/", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    ...serializeRequestMetadataExtensions(ext),
                },
                body: JSON.stringify(payload),
            });
            if (!res.ok) {
                //TODO: handle error properly?
                throw new Error(`Failed to submit form: ${res.statusText}`);
            }
            const cmd = await res.json();
            return cmd;
        },
        async selectOffer(data) {
            const ext = await safeResolveRequestMetadataExtensions(resolveRequestMetadataExtensions);
            const res = await fetch("/api/select-offer/", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    ...serializeRequestMetadataExtensions(ext),
                },
                body: JSON.stringify(data),
            });
            if (!res.ok) {
                throw new Error(`Failed to select offer: ${res.statusText}`);
            }
            const cmd = await res.json();
            return cmd;
        },
    };
};
